<template>
  <div class="h-full overflow-auto">
    <div class="dialog-content">
      <el-form :model="formModel" label-width="150px" class="tech-form">
        <el-row>
          <template v-for="(item, index) in configItems">
            <!-- 布尔类型 -->
            <el-col v-if="item.type === 'bool'" :span="24" :key="`bool-${index}`">
              <el-form-item class="tech-form-item">
                <template #label>
                  <!-- <el-tooltip :content="item.name" placement="top" :enterable="false">
                    <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                  </el-tooltip> -->
                  <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                </template>
                <el-switch
                  v-model="formModel[item.name]"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  class="tech-switch"
                ></el-switch>
              </el-form-item>
            </el-col>

            <!-- 数值类型 -->
            <el-col
              v-else-if="item.type === 'int' || item.type === 'float' || item.type === 'double'"
              :span="24"
              :key="`number-${index}`"
            >
              <el-form-item class="tech-form-item">
                <template #label>
                  <!-- <el-tooltip :content="item.name" placement="top" :enterable="false">
                    <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                  </el-tooltip> -->
                  <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                </template>

                <el-input-number
                  v-model="formModel[item.name]"
                  :precision="item.type === 'float' ? undefined : 0"
                  :controls-position="'right'"
                ></el-input-number>
              </el-form-item>
            </el-col>

            <!-- 向量类型 -->
            <el-col
              v-else-if="item.type === 'int2' || item.type === 'real2' || item.type === 'real3'"
              :span="24"
              :key="`vector-${index}`"
            >
              <el-form-item class="tech-form-item">
                <template #label>
                  <!-- <el-tooltip :content="item.name" placement="top" :enterable="false">
                    <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                  </el-tooltip> -->
                  <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                </template>
                <div class="vector-input-container">
                  <el-input-number
                    v-for="(item2, index2) in item.value"
                    :key="index2"
                    v-model="formModel[item.name][index2]"
                    :precision="0"
                    :controls-position="'right'"
                    class="vector-input"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
            </el-col>

            <!-- 列表类型 -->
            <el-col v-else-if="item.type === 'stringList'" :span="24" :key="`list-${index}`">
              <el-form-item class="tech-form-item">
                <template #label>
                  <!-- <el-tooltip :content="item.name" placement="top" :enterable="false">
                    <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                  </el-tooltip> -->
                  <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                </template>
                <el-select v-model="formModel[item.name]">
                  <el-option
                    v-for="(option, optIndex) in item.dataSource"
                    :key="optIndex"
                    :label="option"
                    :value="option"
                    class="tech-option"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 文本类型 -->
            <el-col v-else-if="item.type === 'string'" :span="24" :key="`string-${index}`">
              <el-form-item class="tech-form-item">
                <template #label>
                  <!-- <el-tooltip :content="item.name" placement="top" :enterable="false">
                    <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                  </el-tooltip> -->
                  <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                </template>
                <el-input v-model="formModel[item.name]" class="tech-input"></el-input>
              </el-form-item>
            </el-col>

            <!-- 颜色类型 -->
            <el-col v-else-if="item.type === 'rgba'" :span="24" :key="`color-${index}`">
              <el-form-item class="tech-form-item">
                <template #label>
                  <!-- <el-tooltip :content="item.name" placement="top" :enterable="false">
                    <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                  </el-tooltip> -->
                  <span class="label-with-tooltip">{{ item.describe || item.name }}</span>
                </template>
                <el-color-picker
                  v-model="formModel[item.name]"
                  class="tech-color-picker"
                ></el-color-picker>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </div>
    <div class="w-full mt-10px flex items-center justify-end">
      <!-- <el-button size="mini" @click="closeComponents" :loading="savaLoading">取消</el-button> -->
      <el-button type="primary" size="mini" @click="handleConfirm">确认</el-button>
      <el-button type="primary" size="mini" @click="handleSave" :loading="savaLoading"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>

let originSettings = []
let userSettings = []
let settingsMap = null
export default {
  name: 'GlobalSetting',
  components: {},
  props: {
    cloudRender: {
      type: Object,
      defalut: () => {
        return {}
      },
    }
  },
  emits: ['confirm'],
  data() {
    return {
      formModel: {},
      savaLoading: false,
      configItems: [],
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async created() {
    this.getPreferenceSettings()
  },
  watch: {
    configItems: {
      immediate: true,
      deep: false,
      handler(newVal) {
        // 将数组转换为对象形式
        this.formModel = newVal.reduce((acc, item) => {
          // 判断是否为数组
          if (Array.isArray(item.value)) {
            acc[item.name] = item.value.map((item2) => item2)
          } else {
            acc[item.name] = item.value
          }
          return acc
        }, {})
      },
    },
  },
  methods: {
    // 获取用户偏好设置
    async getPreferenceSettings() {
      const info = await this.cloudRender.Setting.getAll()
      originSettings = info.data
      const res = await this.cloudRender.Setting.getSettingData(
        `data://../apps/${this.modelSetting.folderName}/settings.json`
      )
      if (res.status && res.data) {
        userSettings = JSON.parse(res.data)
      } else {
        userSettings = { Show: [] }
      }
      settingsMap = new Map(userSettings.Show.map((item) => [item.name, item]))
      this.configItems = [...originSettings]
    },
    updateShowSettings(changeList) {
      // 一次性处理所有更改
      changeList.forEach((change) => {
        settingsMap.set(change.name, { ...change })
      })

      // 将Map转换回数组
      userSettings.Show = Array.from(settingsMap.values())
    },

    getChange() {
      //  判断数组的元素是否相同
      const isEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
          return false
        }
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i] !== arr2[i]) {
            return false
          }
        }
        return true
      }
      const changeList = []
      this.configItems.forEach((item) => {
        if (
          (Array.isArray(item.value) && !isEqual(item.value, this.formModel[item.name])) ||
          (!Array.isArray(item.value) && item.value !== this.formModel[item.name])
        ) {
          changeList.push({
            name: item.name,
            value: this.formModel[item.name],
          })
          item.value = this.formModel[item.name]
        }
      })
      this.updateShowSettings(changeList)
      return changeList
    },
    async handleConfirm() {
      this.savaLoading = true
      const changeList = this.getChange()
      // this.$emit('confirm', changeList)
      await this.cloudRender.Setting.set(changeList)
      this.savaLoading = false
    },
    async handleSave() {
      const changeList = this.getChange()
      await this.cloudRender.Setting.set(changeList)
      const res = await this.cloudRender.Setting.saveSetting(
        `data://../apps/${this.modelSetting.folderName}/settings.json`,
        JSON.stringify(userSettings)
      )
      if (res?.status) {
        this.$message.success('保存设置成功！')
      } else {
        this.$message.warning('保存设置失败！')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 50px);
  padding-right: 30px !important;
  .el-tab-pane {
    overflow-y: auto;
    height: 100%;
  }
}
.dialog-content {
  height: calc(100% - 48px);
  overflow-y: scroll;
}
// ::v-deep .el-select {
//   padding-right: 12px !important;

// }
::v-deep .el-input {
  width: 180px;
}
::v-deep .el-form-item {
  margin-bottom: 10px;
}
</style>
